import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=60df81dc&scoped=true&"
import script from "./Appointment.vue?vue&type=script&lang=js&"
export * from "./Appointment.vue?vue&type=script&lang=js&"
import style0 from "./Appointment.vue?vue&type=style&index=0&id=60df81dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60df81dc",
  null
  
)

component.options.__file = "Appointment.vue"
export default component.exports